export const enum ReplyToPromptStatus {
  HIDDEN = 'HIDDEN',
  FORBIDDEN = 'FORBIDDEN',
  NEW = 'NEW',
  CONTINUE = 'CONTINUE',
}
